// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__rNyrI","topBottomGutter":"Layout_topBottomGutter__19wQb"};